import { getRelativeImagePath } from "../../../util/helper/getRelativeImagePath";
import { stringSplice } from "../../../util/lodash/stringSplice";

/**
 * @imagePath : raybestos-r-line-ceramic-brake-pads/images/003.jpeg
 * @returns : /cms/raybestos-r-line-ceramic-brake-pads/images/thumbnails/001.jpeg
 */
export function getLinePageThumbImagePath(imagePath: any) {
  if (typeof imagePath !== "string" || !imagePath) {
    return "";
  }
  const index = imagePath.lastIndexOf("/");
  const folderName = "/thumbnails";
  return `${process.env.NEXT_PUBLIC_ROOT_URL}/cms/${stringSplice(imagePath, index, 0, folderName)}`;
}

/**
 * @imagePath : raybestos-r-line-ceramic-brake-pads/images/003.jpeg
 * @returns : /cms/raybestos-r-line-ceramic-brake-pads/images/001.jpeg
 */
export function getLinePageProductImagePath(imagePath: any) {
  return getRelativeImagePath(`/cms/${imagePath}`);
}
